import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
	card: {
		backgroundColor: theme.palette.aeros.surface,
		border: `1px solid ${theme.palette.aeros.border}`,
		borderRadius: 12,
		padding: "12px 14px",
		marginBottom: 8,
	},
}));

const TicketsSkeleton = () => {
	const classes = useStyles();

	return (
		<>
			<ListItem dense className={classes.card}>
				<ListItemAvatar>
					<Skeleton animation="wave" variant="circle" width={42} height={42} />
				</ListItemAvatar>
				<ListItemText
					primary={<Skeleton animation="wave" height={20} width={60} />}
					secondary={<Skeleton animation="wave" height={20} width={90} />}
				/>
			</ListItem>
			<ListItem dense className={classes.card}>
				<ListItemAvatar>
					<Skeleton animation="wave" variant="circle" width={42} height={42} />
				</ListItemAvatar>
				<ListItemText
					primary={<Skeleton animation="wave" height={20} width={70} />}
					secondary={<Skeleton animation="wave" height={20} width={120} />}
				/>
			</ListItem>
			<ListItem dense className={classes.card}>
				<ListItemAvatar>
					<Skeleton animation="wave" variant="circle" width={42} height={42} />
				</ListItemAvatar>
				<ListItemText
					primary={<Skeleton animation="wave" height={20} width={60} />}
					secondary={<Skeleton animation="wave" height={20} width={90} />}
				/>
			</ListItem>
		</>
	);
};

export default TicketsSkeleton;
